import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-hondenbelasting',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHondenbelasting {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m0 27 3 1h11c0-1.11.19-2.18.53-3.18L3.59 19.59 0 27.01Zm24-7c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m.96 6.99c.55 0 1 .45 1 1s-.45 1-1 1h-2.57c.25.62.71 1.13 1.35 1.36.48.18 1.01.18 1.49 0 .52-.19 1.09.07 1.29.58.2.52-.07 1.09-.58 1.29-.47.18-.96.26-1.45.26s-.98-.09-1.45-.26c-1.42-.54-2.39-1.79-2.71-3.23h-.36c-.55 0-1-.45-1-1s.45-1 1-1h.37c.04-.16.06-.32.11-.48.39-1.17 1.2-2.1 2.28-2.61 1.02-.49 2.16-.53 3.22-.14.52.2.78.77.58 1.29-.2.52-.77.78-1.29.58-.54-.2-1.13-.18-1.65.07-.53.25-.94.71-1.17 1.29h2.56Z"/>
  <path d="M35.73 6.72c-.24-.38-.68-.72-1.74-.72h-7l-1.05-3.58c-.55-1.37-2.1-2.41-3.6-2.41h-7.53c-.77-.01-1.66.57-2.01 1.31L7.09 12.68l5.35 2.62c.74.35 1.56.3 2.26-.14.42-.26.88-.8.71-1.88l-1.28-5.89 1.52-3.04 1.91 9.11v.24c0 .98-.23 1.85-.62 2.39-.77 1.06-1.81 1.57-3.18 1.57-.51 0-1.2-.18-1.84-.49l-5.66-2.8-1.72 3.43 6.39 3.15 4.42 2.07c1.73-2.99 4.95-5 8.65-5 .33 0 .65.02.97.05l.63-2.06h1.93c2.68 0 5.11-1.05 6.25-3.46l1.94-3.67c.37-.77.37-1.58.01-2.14Zm-14.2.22c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"/>
</svg>

    );
  }
}
